import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DatePicker } from "@mantine/dates";
import { useStoreState } from "pullstate";
import React from "react";
import Store from "../../utils/Store";
import classNames from "classnames";
function DateInput(props) {
  var id = props.id,
    icon = props.icon,
    value = props.value,
    onChange = props.onChange,
    label = props.label,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "DD/MM/YYYY" : _props$placeholder,
    maxDate = props.maxDate,
    inputFormat = props.inputFormat,
    _props$allowFreeInput = props.allowFreeInput,
    allowFreeInput = _props$allowFreeInput === void 0 ? false : _props$allowFreeInput,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    dropdownPosition = props.dropdownPosition,
    _props$clearable = props.clearable,
    clearable = _props$clearable === void 0 ? true : _props$clearable;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isDark: s.isDarkMode
      };
    }),
    isDark = _useStoreState.isDark;
  var style = isDark ? {
    input: {
      fontSize: "16px",
      color: "#D9DBDD"
    }
  } : {
    fontSize: "16px"
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("relative border rounded-md border-gray-500", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement("label", {
    className: classNames("text-md !bg-gray-100 absolute z-10 left-4 -top-3 px-4 dark:!bg-gray-800 sm:!bg-gray-200 sm:dark:!bg-gray-800")
  }, label, " ", !!required && /*#__PURE__*/React.createElement("span", {
    className: "text-red-500 pl-2"
  }, "*")), /*#__PURE__*/React.createElement(DatePicker, {
    icon: icon,
    id: id,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    required: required,
    autoComplete: "off",
    maxDate: maxDate,
    clearable: clearable,
    inputFormat: inputFormat,
    allowFreeInput: allowFreeInput,
    variant: "unstyled",
    className: "flex px-4 items-center w-full",
    dropdownPosition: dropdownPosition,
    styles: _objectSpread({}, _objectSpread({
      dropdown: {
        position: "fixed"
      }
    }, style))
  }));
}
export default DateInput;